import { render, staticRenderFns } from "./FamilyCode.vue?vue&type=template&id=463fcc69&scoped=true&"
import script from "./FamilyCode.vue?vue&type=script&lang=js&"
export * from "./FamilyCode.vue?vue&type=script&lang=js&"
import style0 from "./FamilyCode.vue?vue&type=style&index=0&id=463fcc69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463fcc69",
  null
  
)

export default component.exports